import { config } from './config';
import { ensureValidAccessToken } from './auth';

export interface PhotoItem {
  photoId: string;
  labels: string[];
  people: string[];
  url: string;
}

export interface UploadResponse {
  uploadUrl: string;
  key: string;
}

export async function fetchPhotos(query: string): Promise<PhotoItem[]> {
  const token = await ensureValidAccessToken();
  if (!token) {
    throw new Error('Veuillez vous reconnecter.');
  }

  const params = new URLSearchParams();
  if (query) params.set('q', query);
  params.set('limit', String(config.maxResults));

  const response = await fetch(`${config.apiBaseUrl}/photos?${params.toString()}`, {
    headers: {
      Authorization: `Bearer ${token}`
    }
  });

  if (!response.ok) {
    const text = await response.text();
    throw new Error(`Erreur API (${response.status}): ${text}`);
  }

  const data = await response.json();
  return (data.items || []) as PhotoItem[];
}

export async function requestUploadUrl(file: File, folder: string): Promise<UploadResponse> {
  const token = await ensureValidAccessToken();
  if (!token) {
    throw new Error('Veuillez vous reconnecter.');
  }

  const body = {
    contentType: file.type || 'image/jpeg',
    folder
  };

  const response = await fetch(`${config.apiBaseUrl}/uploads`, {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(body)
  });

  if (!response.ok) {
    const text = await response.text();
    throw new Error(`Impossible de préparer l'upload (${response.status}): ${text}`);
  }

  return (await response.json()) as UploadResponse;
}

export async function uploadFileToS3(uploadUrl: string, file: File): Promise<void> {
  const response = await fetch(uploadUrl, {
    method: 'PUT',
    headers: {
      'Content-Type': file.type || 'image/jpeg'
    },
    body: file
  });

  if (!response.ok) {
    const text = await response.text();
    throw new Error(`Échec d'envoi vers S3 (${response.status}): ${text}`);
  }
}
